module.exports = { "default": require("core-js/library/fn/number/parse-float"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/number/parse-float.js
// module id = 320
// module chunks = 0